import React from "react";
import { Switch, Route } from "react-router-dom";
import Form from "./Form";
import List from "./List";

class UploadRapor extends React.Component {
	render() {
		return (
			<div className="col-sm-12">
				<Switch>
					<Route exact path={`${this.props.match.url}`} component={List} />
					<Route exact path={`${this.props.match.url}/add`} component={Form} />
				</Switch>
			</div>
		);
	}
}

export default UploadRapor;



// WEBPACK FOOTER //
// ./src/views/Exam/UploadRapor/index.js